import { apiClient } from "api";
import { TEditRefProvider, TRefProvider } from "./models/types";
import { AxiosResponse } from "axios";

export const getRefProvidersForAccount = async (accountId: string): Promise<TRefProvider[]> => {
  const response = await apiClient.get(`refproviders/${accountId}`);
  return response.data;
};

export const getRefProviderById = async (
  accountId: string,
  refProviderId: number
): Promise<TEditRefProvider> => {
  const response = await apiClient.get(`refproviders/edit/${accountId}/${refProviderId}`);
  return response.data;
};

export const addOrUpdateRefProvider = async (
  refProvider: TEditRefProvider
): Promise<TRefProvider> => {
  const response = await apiClient({
    method: refProvider.rpId ? "put" : "post",
    url: `refproviders`,
    data: refProvider
  });
  return response.data;
};
